import { createSlice } from "@reduxjs/toolkit";
import { createValuePreparer } from "./reduxUtils";

const initialState = {
  sideBarDrawer: false,
};

const sideBarDrawer = createSlice({
  name: "sideBarDrawer",
  initialState,
  reducers: {
    setSideBarDrawer: {
      prepare: createValuePreparer("sideBarDrawer"),
      reducer(state, action) {
        state.sideBarDrawer = action.payload.sideBarDrawer;
      },
    },
  },
});

export const { setSideBarDrawer } = sideBarDrawer.actions;

export default sideBarDrawer.reducer;
